import { api } from "lib/api"
import useSWR from "swr"

// Only use this client-side
export default function useDeprecatedApiMethod(
  apiMethodName: any,
  apiMethodOptions: any[] = [],
  swrOptions: any = {},
) {
  // https://github.com/vercel/swr#conditional-fetching
  const shouldFetch = !!apiMethodName
  const key = shouldFetch ? [apiMethodName, JSON.stringify(apiMethodOptions)] : null

  const fetcher = async () => {
    // Not needed since fetcher isn't called on null key,
    // but to be explicit and defensive about it
    if (shouldFetch) {
      // @ts-ignore PT - #180597146
      return await api[apiMethodName](...[{ req: undefined }, ...apiMethodOptions])
    } else {
      return null
    }
  }

  const swr = useSWR(key, {
    fetcher,
    ...swrOptions,
  })
  return swr
}
